import React, { useEffect, useState } from "react";
import { X, CheckCircle2, MapPin } from "lucide-react";
import api from "@/lib/api";

const VERBS = {
  enrolled: { txt: "enrolled in", color: "text-emerald-300", dotColor: "bg-emerald-400" },
  demo_booked: { txt: "booked a free demo for", color: "text-amber-300", dotColor: "bg-amber-400" },
  new: { txt: "enquired about", color: "text-[#FF0066]", dotColor: "bg-[#FF0066]" },
  contacted: { txt: "started discussion on", color: "text-blue-300", dotColor: "bg-blue-400" },
};

export default function LiveActivityPopup() {
  const [items, setItems] = useState([]);
  const [visible, setVisible] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let mounted = true;
    api.get("/leads/activity-feed").then(({ data }) => {
      if (mounted) setItems(data.items || []);
    }).catch(() => {});
    return () => { mounted = false; };
  }, []);

  useEffect(() => {
    if (items.length === 0 || dismissed) return;
    let idx = 0;
    const cycle = () => {
      setVisible({ ...items[idx % items.length], ageMin: 1 + Math.floor(Math.random() * 25) });
      // Show for 5s, then hide for 6s, then next
      const hideT = setTimeout(() => setVisible(null), 5000);
      const nextT = setTimeout(() => { idx += 1; cycle(); }, 11000);
      return () => { clearTimeout(hideT); clearTimeout(nextT); };
    };
    const initialDelay = setTimeout(cycle, 4000);
    return () => clearTimeout(initialDelay);
  }, [items, dismissed]);

  if (!visible || dismissed) return null;
  const v = VERBS[visible.stage] || VERBS.new;

  return (
    <div
      className="fixed bottom-20 left-3 md:bottom-6 md:left-6 z-30 max-w-[260px] md:max-w-xs bg-[#0a0a0a]/95 backdrop-blur-md border border-white/10 rounded-xl shadow-2xl px-3 py-2.5 animate-in slide-in-from-left fade-in"
      data-testid="live-activity-popup"
    >
      <button
        onClick={() => setDismissed(true)}
        className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-[#050505] border border-white/10 text-white/40 hover:text-white flex items-center justify-center"
        aria-label="Dismiss"
      >
        <X className="w-3 h-3" />
      </button>
      <div className="flex items-start gap-2.5">
        <div className="relative shrink-0">
          <div className={`w-8 h-8 rounded-full ${v.dotColor}/15 flex items-center justify-center`}>
            <CheckCircle2 className={`w-4 h-4 ${v.color}`} />
          </div>
          <span className={`absolute -bottom-0.5 -right-0.5 w-2 h-2 rounded-full ${v.dotColor} ring-2 ring-[#0a0a0a] animate-pulse`} />
        </div>
        <div className="min-w-0">
          <div className="text-xs text-white/85 leading-snug">
            <b className="text-white">{visible.name}</b> <span className="inline-flex items-center gap-0.5 text-[10px] text-white/50"><MapPin className="w-2.5 h-2.5" /> {visible.city}</span>
          </div>
          <div className="text-[11px] text-white/70 leading-snug mt-0.5">
            {v.txt} <span className={`font-semibold ${v.color}`}>{visible.course}</span>
          </div>
          <div className="text-[9px] text-white/40 mt-1">{visible.ageMin} min ago</div>
        </div>
      </div>
    </div>
  );
}
